/**
 * ─────────────────────────────────────────────
 * src/services/taskImportService.js
 * ─────────────────────────────────────────────
 * Auto Task — build Kanban lists and their tasks from a document.
 *
 *   POST /projects/:projectId/lists/parse    read a file, return a preview
 *   POST /projects/:projectId/lists/import   create the confirmed board
 *
 * Paths are written WITHOUT the "/api" prefix — the shared axios instance
 * supplies it via baseURL.
 */
import api from "../lib/api";

// ─────────────────────────────────────────────
// READ A FILE FROM THIS DEVICE
//
// Returns the lists and tasks found, saving nothing. The longer timeout
// matches the other AI-backed endpoints: a big breakdown genuinely takes a
// while, and the 30s default would look like a broken feature.
// ─────────────────────────────────────────────
const parseFile = async (projectId, file) => {
  const form = new FormData();
  form.append("file", file);
  const response = await api.post(`/projects/${projectId}/lists/parse`, form, {
    timeout: 180000,
    headers: { "Content-Type": undefined },
  });
  return response.data;
};

// ─────────────────────────────────────────────
// SAME, FROM GOOGLE DRIVE
// The backend downloads it with the short-lived token the picker returned.
// ─────────────────────────────────────────────
const parseDriveFile = async (projectId, { fileId, token }) => {
  const response = await api.post(
    `/projects/${projectId}/lists/parse`,
    { driveFileId: fileId, driveToken: token },
    { timeout: 180000 },
  );
  return response.data;
};

// ─────────────────────────────────────────────
// CREATE THE BOARD
// Only the lists and tasks the user kept are sent.
// ─────────────────────────────────────────────
const importBoard = async (projectId, lists) => {
  const response = await api.post(`/projects/${projectId}/lists/import`, {
    lists,
  });
  return response.data;
};

const taskImportService = { parseFile, parseDriveFile, importBoard };

export default taskImportService;
